const sliderStep = {
  metric: 0.1,
  imperial: 0.396875
};

export default sliderStep;
